import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'Mailboxes/Management'

export const EDIT_ASYNC = createAsyncTypes('EDIT_ASYNC', typeKey)
export const STATUS_TOGGLE_ASYNC = createAsyncTypes('STATUS_TOGGLE_ASYNC', typeKey)
export const TAG_REMOVE_ASYNC = createAsyncTypes('TAG_REMOVE', typeKey)

export const SELECT_TOGGLE = `${typeKey}/SELECT_TOGGLE`
